<template>
  <TableLayout :permissions="['meihui:shareTemplate:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="模板配置ID"><el-input v-model="searchForm.templateConfigId" placeholder="模板配置ID" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建手记模板')" icon="el-icon-plus" v-permissions="['meihui:shareTemplate:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:shareTemplate:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="templateConfigId" label="模板配置ID" width="120" show-overflow-tooltip />
        <el-table-column prop="wechatShareText" label="微信分享" width="120" show-overflow-tooltip />
        <el-table-column prop="momentsShareText" label="朋友圈" width="120" show-overflow-tooltip />
        <el-table-column prop="generateKnowledgeText" label="知识图文" width="120" show-overflow-tooltip />
        <el-table-column prop="generateTitleText" label="生成标题" width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑手记模板', row)" icon="el-icon-edit" v-permissions="['meihui:shareTemplate:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:shareTemplate:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operashareTemplateWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operashareTemplateWindow from './operashareTemplateWindow'
export default {
  name: 'ShareTemplate', extends: BaseTable, components: { TableLayout, Pagination, operashareTemplateWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '手记模板', api: '/rentHouse/shareTemplate', 'field.id': 'id', 'field.main': 'id' })
    this.search()
  }
}
</script>